// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{transition:.2s ease-in-out}.width-not-loaded{opacity:0}", ""]);
// Exports
module.exports = exports;
